import ProfileSettings from '@Services/ProfileSettings';
import { profileSettingsSetIsLoadingReducerType } from './ProfileSettingsConstants';

export function setIsLoading(isLoading) {
  return {
    type: profileSettingsSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export const init = () => {
  return async (dispatch) => {
    await ProfileSettings.loadProfileSettingsInfo();
    dispatch(setIsLoading(false));
  };
};
